import { Injectable } from "@angular/core";

import { NotificationService } from "@core/services/notification.service";
import { ReportsService } from "@core/services/reports.service";
import { ExchangeInformationType } from "@enums/exchange-information-type";
import { ReportType } from "@enums/report-type";
import { ToasterSeverities } from "@enums/toaster-severities";
import * as reportsActions from "@features/reports-panel/store/reports.actions";
import { IExchangeInfo } from "@models/exchange-info.model";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { catchError, mergeMap, Observable, of, switchMap } from "rxjs";

@Injectable()
export class ReportsEffects {
  reportType = ReportType;
  exchangeType = ExchangeInformationType;

  saveReport$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(reportsActions.SAVE_REPORT),
      mergeMap(
        (actions: {
          path: ReportType;
          intermediaryId?: string;
          exchangeInfo?: Partial<IExchangeInfo>;
          annualReportDate?: string | number;
        }): Observable<Action> => {
          if (
            actions.path === this.reportType.ExchangeInformation ||
            actions.path === this.reportType.AnnualReport
          ) {
            return this.reportsService
              .saveReport$(
                actions.path,
                actions.exchangeInfo,
                actions.annualReportDate
              )
              .pipe(
                switchMap((): Observable<Action> => {
                  if (
                    actions.exchangeInfo?.exchangeInformationType ===
                    this.exchangeType.AccountAccumulation
                  ) {
                    this.notificationService.show(
                      ToasterSeverities.Success,
                      "INFORMATION_EXCHANGE_BACKGROUND"
                    );
                  } else {
                    this.notificationService.show(
                      ToasterSeverities.Success,
                      "ANNUALSTATEMENT_BACKGROUND"
                    );
                  }
                  return of();
                }),
                catchError((): Observable<Action> => {
                  return of();
                })
              );
          } else {
            return this.reportsService
              .getReport$(actions.path, actions.intermediaryId)
              .pipe(
                switchMap((): Observable<Action> => {
                  let messageKey: string | null = null;
                  switch (true) {
                    case actions.path.includes(this.reportType.Intermediary):
                      messageKey = "INTERMEDIARY_BACKGROUND";
                      break;
                    case actions.path.includes(this.reportType.Advisor):
                      messageKey = "ADVISOR_REPORT_BACKGROUND";
                      break;
                    case actions.path.includes(
                      this.reportType.AccountManagement
                    ):
                      messageKey = "ACCOUNT_MANAGEMENT_BACKGROUND";
                      break;
                    case actions.path.includes(this.reportType.CRM):
                      messageKey = "CRM_DUMP_BACKGROUND";
                      break;
                  }
                  if (messageKey) {
                    this.notificationService.show(
                      ToasterSeverities.Success,
                      messageKey
                    );
                  }
                  return of();
                }),
                catchError((): Observable<Action> => {
                  return of();
                })
              );
          }
        }
      )
    );
  });

  constructor(
    private actions$: Actions,
    private reportsService: ReportsService,
    private notificationService: NotificationService
  ) {}
}
